import { App } from 'antd';
import React, { FC, PropsWithChildren } from 'react';

export const NotificationsProvider: FC<PropsWithChildren> = (props) => {
  return <App>{props.children}</App>;
};
